import React, { CSSProperties } from 'react'
import { Button, Dropdown, DropdownProps, Icon } from 'semantic-ui-react'

interface Props {
  options: DropdownData[];
  multiple?: boolean;
  search?: boolean;
  placeholder?: string;
  title?: string;
  value?: string | number;
  button?: boolean;
  buttonContent?: string;
  icon?: string | JSX.Element;
  className?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  disabledDropdown?: boolean;
  closeOnChange?: boolean;
  onClick?: () => void;
  changeOption: (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => void;
  'data-testid'?: string;
}

export interface DropdownData {
  key: string | number;
  text: string | number | JSX.Element;
  value: string | number;
  image?: JSX.Element;
  detailIcon?: JSX.Element;
  closeIcon?: JSX.Element;
  disabled?: boolean;
  description?: string;
}

const DropdownComponent = (props: Props): JSX.Element => {

  const handleCloseDropdown = (event: React.MouseEvent<HTMLElement>, value: string | number) => {
    if (value === props.value) {
      event.stopPropagation()
    }
  }

  const renderHeader = () => {
    if (props.title) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', opacity: '.4', marginTop: '.5rem' }}>
          <hr style={{ width: '4rem', marginLeft: '1rem', marginRight: '1rem' }} />
          <span >{props.title}</span>
          <hr style={{ width: '4rem', marginLeft: '1rem', marginRight: '1rem' }} />
        </div>
      )
    }
    return null
  }

  const renderOptions = () => {
    if (props.options) {
      return props.options.map(item => {
        return {
          key: item.key,
          text: item.text,
          value: item.value,
          disabled: item.disabled,
          content: (
            <div onClick={e => handleCloseDropdown(e, item.value)}>
              <div style={{ display: 'flex', height: '1rem', whiteSpace: 'nowrap' }}>
                {item.image ? item.image : null}
                {typeof item.text === 'object' ? item.text : <p style={{ marginLeft: '.3rem', marginRight: '1rem', width: '15rem' }}>{item.text}</p>}
                {item.description ? <p style={{ fontSize: '12px', opacity: .4, marginTop: '2px' }}>{item.description}</p> : null}
              </div>
              <div>
                {item.detailIcon ? item.detailIcon : null}
                {item.closeIcon ? item.closeIcon : null}
              </div>
            </div>
          )
        }
      })
    }
  }

  const handleChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
    props.changeOption(event, data)
  }

  const renderButton = () => {
    if (props.button) {
      return (
        <Button
          primary={true}
          style={{ borderRadius: '0px 6px 6px 0px', width: '10%', padding: '0rem' }}
          content={props.buttonContent} onClick={props.onClick}
        />
      )
    } else if (props.icon === '') {
      return (
        <Button
          icon
          style={{ border: '1px solid #d7d7d7', borderRadius: '0px 8px 8px 0px', backgroundColor: '#FFF', borderLeft: 'none', margin: '0', padding: '.6rem .6rem 1.5rem .6rem' }}
          content={<Icon name='plus circle' onClick={props.onClick} />}
        />
      )
    }
    return null
  }

  return (
    <div style={{ width: props.width ? props.width : '20rem', display: 'flex', height: props.height ? props.height : '', cursor: props.disabledDropdown ? 'no-drop' : 'auto' }}>
      <Dropdown
        disabled={props.disabledDropdown}
        className={props.className}
        fluid
        selection
        options={renderOptions()}
        header={renderHeader()}
        placeholder={props.placeholder}
        search={props.search}
        multiple={props.multiple}
        style={{ ...props.style }}
        value={props.value}
        onChange={handleChange}
        icon={props.icon}
        closeOnChange={props.closeOnChange}
        selectOnBlur={false}
        data-testid={props['data-testid']}
      />
      {renderButton()}
    </div>
  )
}

export default DropdownComponent
